"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ExtendableError_1 = __importDefault(require("../ExtendableError"));
/**
 * Thrown when SQL statement is rejected from database
 * @param {string} explanation
 */
class InvalidSqlStatementError extends ExtendableError_1.default {
    constructor(vendorError) {
        super(`Invalid SQL statement. ${vendorError.message}`);
        this.vendorError = vendorError;
    }
}
exports.default = InvalidSqlStatementError;
